import { render, staticRenderFns } from "./tree-navigation.vue?vue&type=template&id=72eff1d0&scoped=true"
import script from "./tree-navigation.vue?vue&type=script&lang=js"
export * from "./tree-navigation.vue?vue&type=script&lang=js"
import style0 from "./tree-navigation.vue?vue&type=style&index=0&id=72eff1d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72eff1d0",
  null
  
)

export default component.exports